export const GET_DATA = 'GET_DATA';

export const GET_POOL_INFO = 'GET_POOL_INFO';
export const GET_POOL_INFO_LOADING = 'GET_POOL_INFO_LOADING';
export const GET_POOL_INFO_SUCCESS = 'GET_POOL_INFO_SUCCESS';
export const GET_POOL_INFO_ERROR = 'GET_POOL_INFO_ERROR';
